import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Header } from './components/header.tsx';
import './css/app.css';
import Router from './router';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0C3148'
    },
    secondary: {
      main: '#D20A11'
    },
  },
  typography: {
    fontFamily: [
      'IranSans'
    ].join(','),
  },
  direction: 'rtl'
});

function App() {


  return (
    <div >
      <ThemeProvider theme={theme}>
        <Header />
        <div className='mainContainer'>

          <ToastContainer position="top-left" newestOnTop />
          <Router />
          {/* <Home/> */}
        </div>
      </ThemeProvider>
    </div>
  );
}

export default App;
